module.exports = __webpack_public_path__ + "/img/c2577c7e2966f35a127e215bd191be01.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/course-option.png
 ** module id = 19
 ** module chunks = 0 1 2 3 4 5
 **/